import { render } from "./FrmInventoryRegularizationHome.vue?vue&type=template&id=2ab515f7"
import script from "./FrmInventoryRegularizationHome.vue?vue&type=script&lang=js"
export * from "./FrmInventoryRegularizationHome.vue?vue&type=script&lang=js"

import "./FrmInventoryRegularizationHome.vue?vue&type=style&index=0&id=2ab515f7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__